import { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { request } from "components/utils/Request2";
import { getFilePropsFromResponse, showFile } from "components/filepreview/FilePreview";

interface InvoicePdfPreviewProps {
	invoiceId: number;
	/** Bumped by the parent whenever the invoice is refetched, so the preview is regenerated. */
	refreshKey?: number;
}

const InvoicePdfPreview = ({ invoiceId, refreshKey = 0 }: InvoicePdfPreviewProps) => {

	const [ response, setResponse ] = useState<{ pdf: string }>();

	useEffect(() => {
		let cancelled = false;
		request<{ pdf: string }>({
			url: `invoices/preview/${invoiceId}`,
			method: "GET",
		}).then(res => {
			if (!cancelled) {
				setResponse(res);
			}
		});
		return () => {
			// a newer request has started, so ignore this one's response
			cancelled = true;
		};
	}, [ invoiceId, refreshKey ]);

	if (!response) {
		return (
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", padding: 2 }}>
				<CircularProgress size={24} />
			</Box>
		);
	}

	const fileProps = getFilePropsFromResponse(response);
	return (
		<Box sx={{ display: "flex", height: "100%", "& > iframe": { height: "100%", minHeight: 0 } }}>
			{showFile(fileProps.file, fileProps.type)}
		</Box>
	);
};

export default InvoicePdfPreview;
